import { name as root } from '../actionTypes';

export const name = `${root}/contacts`;

export const FETCH_CONTACTS_REQUEST = `${name}/fetch/request`;
export const FETCH_CONTACTS_SUCCESS = `${name}/fetch/success`;
export const FETCH_CONTACTS_FAILURE = `${name}/fetch/failure`;
export const SAVE_CONTACTS_REQUEST = `${name}/save/request`;
export const SAVE_CONTACTS_SUCCESS = `${name}/save/success`;
export const SAVE_CONTACTS_FAILURE = `${name}/save/failure`;
export const CONTACT_SELECTED = `${name}/selected`;
export const CONTACT_CLOSED = `${name}/closed`;
export const CONTACT_SHIFT_LEFT = `${name}/shiftleft`;
export const CONTACT_SHIFT_RIGHT = `${name}/shiftright`;
export const TOGGLE_PANEL = `${name}/togglePanel`;
export const TOGGLE_BUTTON = `${name}/toggleButton`;